module.exports = __webpack_public_path__ + "img/dashi-banner.8f8f995d.jpg";